"use client"

// src/components/em.ts
var Em = {
  baseStyle: {
    fontStyle: "italic"
  }
};

export {
  Em
};
//# sourceMappingURL=chunk-DF3KCDHA.mjs.map